export interface NormalizedListResponse<T> {
  data: T[];
  total: number;
}

type EnvelopeMeta = { total?: number; limit?: number; offset?: number };
type EnvelopeShape<T> =
  | T[]
  | { data: T[]; meta?: EnvelopeMeta; total?: number; limit?: number; page?: number; offset?: number };

export function normalizeListResponse<T>(res: EnvelopeShape<T>): NormalizedListResponse<T> {
  if (Array.isArray(res)) {
    return { data: res, total: res.length };
  }
  const data = Array.isArray(res.data) ? res.data : [];
  const metaTotal = res.meta?.total;
  const flatTotal = res.total;
  const total = typeof metaTotal === 'number' ? metaTotal
    : typeof flatTotal === 'number' ? flatTotal
    : data.length;
  return { data, total };
}
